module.exports = __webpack_public_path__ + "static/media/Soleil-Light.74bad3db.otf";